(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-reason-gallery"]) return;
  try {
    
      function waitForSwiper(trigger) {
            var interval = setInterval(function () {
                if (typeof Swiper != 'undefined') {
                    clearInterval(interval);
                    trigger();
                }
            })
            setTimeout(function () {
                clearInterval(interval);
            }, 15000)
        }
    function gallerySlider() {
            var swiper = new Swiper('.swiper-container.product-gallery', {
                 slidesPerView: 1,
                 navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }
              
            });
        }

   function switchSlider() {
            var swiper = new Swiper('.swiper-container.product-switchers', {
                 slidesPerView: 3,
                 navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }
              
            });
        }
        waitForSwiper(function () {
            gallerySlider();
          switchSlider();
        })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
    const accordionTitles = document.querySelectorAll(".accordionTitle");
    
      accordionTitles.forEach((accordionTitle) => {
      accordionTitle.addEventListener("click", () => {
      if (accordionTitle.classList.contains("is-open")) {
      accordionTitle.classList.remove("is-open");
      } else {
      const accordionTitlesWithIsOpen = document.querySelectorAll(".is-open");
      accordionTitlesWithIsOpen.forEach((accordionTitleWithIsOpen) => {
      accordionTitleWithIsOpen.classList.remove("is-open");
      });
      accordionTitle.classList.add("is-open");
      }
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fan-fav"] && !Shopify.designMode) return;
  try {
    
 var cards = document.querySelectorAll('.card');

        cards.forEach(function(card) {
            var tabs = card.querySelectorAll('.tabs .tab');
            var productImages = card.querySelectorAll('.product_images img');

            tabs.forEach(function(tab) {
                tab.addEventListener('click', function() {
                    // Remove the 'active' class from all tabs within this card
                    tabs.forEach(function(t) {
                        t.classList.remove('active');
                    });
                    // Add 'active' class to the clicked tab
                    tab.classList.add('active');
                    // Change the image source based on the data-image attribute of the clicked tab
                    productImages.forEach(function(image) {
                        image.src = tab.getAttribute('data-image');
                    });
                });
            });
        });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-faq"] && !Shopify.designMode) return;
  try {
    
    const accordionTitles = document.querySelectorAll(".accordionTitle");
    
      accordionTitles.forEach((accordionTitle) => {
      accordionTitle.addEventListener("click", () => {
      if (accordionTitle.classList.contains("is-open")) {
      accordionTitle.classList.remove("is-open");
      } else {
      const accordionTitlesWithIsOpen = document.querySelectorAll(".is-open");
      accordionTitlesWithIsOpen.forEach((accordionTitleWithIsOpen) => {
      accordionTitleWithIsOpen.classList.remove("is-open");
      });
      accordionTitle.classList.add("is-open");
      }
      });
    });

  } catch(e) { console.error(e); }
})();
})();
